import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import { Col, Container, Row } from 'react-bootstrap';
import { graphql } from 'gatsby';
import { SPostContent, SSection, STitle } from './styles';

import SEO from 'components/seo';

// Pulling page from wordpress and making standalone pages is not done, so ignore below code till done

const SingleWpPageTemplate = ({ data }) => {
  const page = data.wpPage;
  const resolutions = page.featuredImage
    ? page.featuredImage.node.localFile.childImageSharp.gatsbyImageData
    : null;

  return (
    <Layout logoType="light">
      <SEO
        useTitleTemplate={false}
        title={page.seo.title}
        description={page.seo.metaDesc}
        schemaMarkup={{
          '@type': 'NewsArticle',
          headline: page.seo.title,
          image: [resolutions?.src],
          datePublished: page.date,
          dateModified: page.modified,
          author: {
            '@type': 'Person',
            name: 'Sam Ghosh',
          },
          address: undefined,
          publisher: {
            '@type': 'Organization',
            name: 'Oasis Living',
            logo: {
              '@type': 'ImageObject',
              url:
                'https://oasis-static-files.s3.eu-west-2.amazonaws.com/logo_blue.png',
            },
          },
        }}
      />
      {/* <TitleHeader title={page.seo.title} isBlogPost={true} /> */}
      <SSection>
        <Container>
          <Row>
            <Col xs="12">
              <STitle> {page.seo.title}</STitle>
              <SPostContent
                className="single-blog-post-content"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />
            </Col>
          </Row>
        </Container>
      </SSection>
    </Layout>
  );
};

SingleWpPageTemplate.propTypes = {
  data: PropTypes.object,
};

export default SingleWpPageTemplate;

export const pageQuery = graphql`
  query($id: String!) {
    wpPage(id: { eq: $id }) {
      content
      date(formatString: "MMM DD, YYYY")
      modified(formatString: "MMM DD, YYYY")
      seo {
        canonical
        metaDesc
        focuskw
        metaKeywords
        title
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
